import isRelativeUrl from 'is-relative-url';
import { WixUser } from '../../store';
import { UserAuthData } from '../../types';

export const getWixResizedImage = (relativeUrl: string, width: number, height: number): string => {
  return Wix.Utils.Media.getResizedImageUrl(relativeUrl, width, height);
};

export const getWidgetBgDesktopImage = (url?: string): string => {
  if (!url) {
    return '';
  }

  return isRelativeUrl(url) ? getWixResizedImage(url, 920, 600) : url;
};

export const getWidgetBgMobileImage = (url?: string): string => {
  if (!url) {
    return '';
  }

  return isRelativeUrl(url) ? getWixResizedImage(url, 390, 800) : url;
};

export const getLuckyPrizeImage = (url?: string): string => {
  if (!url) {
    return '';
  }

  return isRelativeUrl(url) ? getWixResizedImage(url, 250, 250) : url;
};

export const isWixUser = (user: WixUser | UserAuthData): user is WixUser => 'accessToken' in user;
